import angular from 'angular'
import ScheduleCalendarComponent from './schedule-calendar.component'
import { ScheduleInspectorComponent } from './inspector/schedule-inspector.component'
import { PreflightReportComponent } from './preflight/preflight-report.component'

import jumbotronDialog from 'common/jumbotron-dialog.directive'
import SceneCollectionService from 'common/scenecollection.service'

export default angular
  .module('scheduleCalendar', [
    jumbotronDialog,
    SceneCollectionService
  ])
  .component('scheduleCalendar', ScheduleCalendarComponent)
  .component('scheduleInspector', ScheduleInspectorComponent)
  .component('preflightReport', PreflightReportComponent)
  .name
